import { render, staticRenderFns } from "./ContentCardMobile.vue?vue&type=template&id=054508ec"
import script from "./ContentCardMobile.vue?vue&type=script&lang=js"
export * from "./ContentCardMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports